import * as React from "react";
const CrmVendasIcon = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320.79 327.06"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #063bb5;\n      }\n    "}</style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path
        className="cls-1"
        d="M253.8,72.15h-102.41v23h84.46v74.22h23v-92.17c0-2.78-2.27-5.05-5.05-5.05Z"
      />
      <path
        className="cls-1"
        d="M273.13,0h-106.34c-26.29,0-47.64,21.36-47.64,47.64v106.34c0,26.28,21.35,47.66,47.64,47.66h6.29v18.5c0,4.27,2.3,8.21,6.01,10.29,1.82,1.01,3.79,1.51,5.79,1.51,2.15,0,4.27-.55,6.14-1.72l44.83-27.29v86.22c0,8.22-6.69,14.91-14.91,14.91H37.91c-8.22,0-14.91-6.69-14.91-14.91V110.06c0-8.22,6.69-14.91,14.91-14.91h72.59v-23H37.91C16.98,72.15,0,89.13,0,110.06v179.09c0,20.95,16.98,37.91,37.91,37.91h183.03c20.93,0,37.91-16.96,37.91-37.91v-87.51h14.28c26.28,0,47.66-21.38,47.66-47.66V47.64c0-26.28-21.38-47.64-47.66-47.64ZM297.16,153.98c0,13.27-10.77,24.03-24.03,24.03h-38.47c-2.17,0-4.29.61-6.14,1.72l-31.81,19.38v-9.3c0-6.52-5.31-11.8-11.83-11.8h-18.09c-13.25,0-24.04-10.76-24.04-24.03V44.34h.23c1.61-11.69,11.68-20.73,23.81-20.73h106.34c13.26,0,24.03,10.79,24.03,24.03v106.34Z"
      />
      <path
        className="cls-1"
        d="M142.75,44.34v3.3c0-1.12.08-2.22.23-3.3h-.23Z"
      />
      <path
        className="cls-1"
        d="M142.98,44.34c-.15,1.08-.23,2.18-.23,3.3v-3.3h.23Z"
      />
    </g>
  </svg>
);
export default CrmVendasIcon;
